import { useMemo, useState } from 'react';
import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/feature/SectionHeading';
import { galleryItems } from '@/mocks/home';

const tabs = ['全部', '街拍', '幕后', '花絮', '纪实', '收藏'];

export default function GalleryPreview() {
  const [active, setActive] = useState('全部');

  const list = useMemo(
    () => (active === '全部' ? galleryItems : galleryItems.filter((item) => item.category === active)),
    [active],
  );

  return (
    <section id="gallery" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <SectionHeading
          eyebrow="图文并重"
          icon="ri-image-2-line"
          title="资源库图集预览"
          desc="先看图再决定收哪套，预览池里的每一张都能在对应合集里找到完整版本。"
          action="进入完整图库"
        />

        <div className="mb-6 flex flex-wrap gap-2">
          {tabs.map((tab) => (
            <button
              key={tab}
              type="button"
              onClick={() => setActive(tab)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                active === tab
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-2 gap-4 md:grid-cols-3 lg:grid-cols-4">
          {list.map((item, index) => (
            <Reveal key={item.id} delay={index * 50}>
              <figure className="group relative h-52 w-full cursor-pointer overflow-hidden rounded-lg border border-background-200 md:h-60">
                <img
                  src={item.img}
                  alt={`${item.title} · ${item.category}`}
                  title={`${item.title} · 爱黑料网资源库`}
                  className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/10 to-transparent opacity-90"></div>
                <figcaption className="absolute inset-x-0 bottom-0 p-4">
                  <span className="rounded-md bg-accent-500 px-2 py-0.5 text-[11px] font-medium text-foreground-950">
                    {item.category}
                  </span>
                  <p className="mt-2 font-heading text-sm font-bold text-background-50 md:text-base">{item.title}</p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}